/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `pending` - Pending
 * * `confirmed` - Confirmed
 * * `processing` - Processing
 * * `failed` - Failed
 * * `replaced` - Replaced
 */
export enum DocumentStatusEnum {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    PROCESSING = 'processing',
    FAILED = 'failed',
    REPLACED = 'replaced',
}
